var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.572,
    height: 16.572,
    viewBox: "0 0 16.572 16.572",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-close",
    "data-name": "Icon ionic-md-close",
    d: "M24.1,9.181,22.439,7.523,15.81,14.153,9.181,7.523,7.523,9.181l6.629,6.629L7.523,22.439,9.181,24.1l6.629-6.629L22.439,24.1,24.1,22.439,17.467,15.81Z",
    transform: "translate(-7.523 -7.523)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnClose);
export default __webpack_public_path__ + "static/media/btn-close.49706d6d2ba44fc27da94b22ebf09883.svg";
export { ForwardRef as ReactComponent };